import styled from 'styled-components'
import TextButton from './TextButton'

/**
 * A text button with an outline style (transparent background, border matches text color).
 * Use within a default Pane for dark text on light backgrounds.
 */
const OutlineTextButton = styled(TextButton)`
  --button-color: ${props => props.theme.palette.neutral.default.one};
  --button-background-color: transparent;
  --button-border-color: ${props => props.theme.palette.neutral.default.one};
`

/**
 * An inverse outline text button for use within inverse Panes (light text on dark backgrounds).
 */
export const InverseOutlineTextButton = styled(TextButton)`
  --button-color: white;
  --button-background-color: transparent;
  --button-border-color: white;
`

export default OutlineTextButton
